module.exports = __webpack_public_path__ + "img/pause.7375c856.svg";